import script from "./dol-query-form.vue?vue&type=script&lang=js"
export * from "./dol-query-form.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__